import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  admin: {
    id: 'frontbucket.repository.admin.breadcrumbs.repodetails',
    description: 'Text to display for repository settings breadcrumb link',
    defaultMessage: 'Repository settings',
  },
});
